import { overrideReadOnly, buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDDisplayText, FDHeadlineText } from '@facet-wealth/design';

export const NormalOverrides = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'lg', color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('stepName', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly);

export const HeroSectionOverrides = buildFacetDesignOverride()
  .nameOverride('heroText', {
    _component: () => Text,
    _customProps: { Component: FDDisplayText, size: 'lg', color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'md' },
  }, overrideReadOnly);
